import { Dialog } from 'primereact/dialog';
import { Divider } from 'primereact/divider';

import { InputText } from 'primereact/inputtext';
import { InputTextarea } from 'primereact/inputtextarea';
import { Button } from 'primereact/button';
import classes from './addModal.module.scss';
import useAddModal from './useAddModal';
import { observer } from 'mobx-react';
import { NDCFormFieldsTypes } from 'Interfaces/FactsInterfaces/drugInterfaces';

const AddModal = ({
  visibility,
  toggleVisibility,
  modalHeading,
  handleNewStrategySelect,
  fieldType,
}: {
  visibility: boolean;
  toggleVisibility: () => void;
  modalHeading: string;
  handleNewStrategySelect: (
    option: { code: string; name: string },
    fieldType: NDCFormFieldsTypes
  ) => void;
  fieldType: NDCFormFieldsTypes;
}) => {
  const {
    name,
    setName,
    description,
    setDescription,
    addMethods,
    isAddLoading,
    errors,
    setErrors,
  } = useAddModal({ handleNewStrategySelect, fieldType });

  return (
    <Dialog
      blockScroll
      resizable={false}
      draggable={false}
      headerClassName={classes.modalHeader}
      header={`Add ${modalHeading === 'PPSSC' ? 'PPS Reason' : modalHeading}`}
      visible={visibility}
      style={{ width: '55vw' }}
      onHide={() => {
        if (!visibility) return;
        toggleVisibility();
      }}
    >
      <div className={classes.modalContainer} style={{ gap: '2rem' }}>
        <Divider className={classes.devider} />
        <div className={classes.inputTextDivWrapper}>
          <label htmlFor="username">{`Name`}</label>
          <InputText
            ref={input => !name && input?.focus()}
            autoFocus
            type="text"
            name={name}
            onChange={e => setName(e.target.value)}
            aria-describedby="username-help"
            minLength={1}
            maxLength={100}
          />
          <div className={classes.counterContatiner}>{name.length}/100</div>
        </div>

        <div className={classes.inputTextDivWrapper}>
          <label htmlFor="username">{`Description`}</label>
          <InputTextarea
            value={description}
            onChange={e => setDescription(e.target.value)}
            aria-describedby="username-help"
            minLength={1}
            maxLength={255}
            style={{ resize: 'none' }}
          />
          <div className={classes.counterContatiner}>{description.length}/255</div>
        </div>
        {errors && (
          <div className={classes.errorWrapper}>
            <span>*{errors}</span>
          </div>
        )}
        <div className={classes.buttonWrapper}>
          <Button
            className={classes.cancelButton}
            onClick={() => {
              setName(() => '');
              setDescription(() => '');
              toggleVisibility();
              setErrors(() => '');
            }}
          >
            Cancel
          </Button>
          <Button
            loading={isAddLoading}
            className={classes.addButton}
            onClick={() => {
              if (modalHeading === 'PPS') {
                addMethods.handleAddPPS();
              } else if (modalHeading === 'PPSSC') {
                addMethods.handleAddPPSC();
              } else if (modalHeading === 'Segmentation') {
                addMethods.handleAddSegmentation();
              } else if (modalHeading === 'DPStrategy') {
                addMethods.handleAddDPStrategy();
              }
            }}
          >
            Add
          </Button>
        </div>
      </div>
    </Dialog>
  );
};

export default observer(AddModal);
